import mountChatInputPanel from '../../../components/chatInputPanel';
import {
    RESPONSE_TYPE_PARTICIPENT_JOINDED,
    RESPONSE_TYPE_FROM_AGENT,
    RESPONSE_TYPE_MESSAGE,
    WAKEUP_PING,
    WRAPPER_GROUP_NAME,
} from 'Container/Ui/constants';
import { handleOptions } from '../../Ui/helpers/handleOptions';
import { renderButton } from '../../Ui/helpers/renderButton';
import { renderChatBubbles } from '../../Ui/helpers/renderWebchatBubbles';
import { renderContainerForWebchatContent } from 'Container/Ui/helpers/renderContainerForWebchatContent';
import { scrollWebchatContent } from 'Container/Refresh/helpers/scrollWebchatContent';
import { IButtonLink } from 'Container/Ui/types';

/**
 * Render Components based on the response
 * @param parsedJson
 * @param actionSendMessage
 */
const renderAllComponents = (
    parsedJson: any,
    actionSendMessage: (message: string) => void,
): string => {
    const chatInputPanel = mountChatInputPanel(actionSendMessage);
    let chatWrapperId = '';

    if (parsedJson.text) {
        const textLen = parsedJson.text.length;

        // render wrapper container
        if (0 < textLen) {
            chatWrapperId = renderContainerForWebchatContent(
                WRAPPER_GROUP_NAME,
            );
        }

        for (let i = 0; i < textLen; i++) {
            const textElement = parsedJson.text[i];
            // MOUNT CHATBUBBLE
            if (textElement.message && 0 < textElement.message.length) {
                renderChatBubbles([textElement.message], false, chatWrapperId);
            }
            // MOUNT BUTTONS
            if (textElement.links && 0 < textElement.links.length)  {
                renderButton(textElement.links, chatWrapperId);
            }

            // MOUNT OPTIONPICKERS
            if (textElement.options && 0 < textElement.options.length) {
                handleOptions(
                    textElement.options,
                    actionSendMessage,
                    chatWrapperId,
                );
            }
        }
    }

    // Enable/Disable Chat-Input
    if (parsedJson.disableFreetext) {
        chatInputPanel.disableChatInput();
    } else {
        chatInputPanel.enableChatInput();
    }

    return chatWrapperId;
};

/**
 * render a webchat content or trigger action based on response
 * TODO: refactor if time is there
 * @param response
 * @param webchatConfig
 * @param actionSendMessage
 * @param actionHandoverToAgent
 * @param agent
 */
export const renderWebchatResponse = (
    response,
    nextPosition: number,
    botName: string,
    actionSendMessage: (message: string) => void,
    actionHandoverToAgent: () => void,
    messageFromAgentOrBotHasSent: () => void,
    agent = false,
) => {
    let chatBubblesWrapperId = '';

    for (let i = 0; i < response.length; i++) {
        const webchatResponse = response[i];

        // if response is not from an agent skip (e.g. echo response from client)
        if (RESPONSE_TYPE_FROM_AGENT !== webchatResponse.from.type) {
            continue;
        }

        if (RESPONSE_TYPE_PARTICIPENT_JOINDED === webchatResponse.type) {
            if (webchatResponse.from.nickname === botName) {
                // if bot joined start communication by sending "hello"
                //  Initial message bound to "nextPosition: 3" so that message is only triggered at initial "Participant join" and subsequent "Rejoins" (for example in case of auth via SecureForm) are ignored.
                if (3 >= nextPosition) {
                    actionSendMessage(WAKEUP_PING);
                }
            } else {
                // if someone else joins the chat trigger handover action
                actionHandoverToAgent();
            }
        }

        if (RESPONSE_TYPE_MESSAGE === webchatResponse.type) {
            // call the new action
            messageFromAgentOrBotHasSent();

            if (!agent) {
                const parsedJson = JSON.parse(webchatResponse.text);
                chatBubblesWrapperId = renderAllComponents(
                    parsedJson,
                    actionSendMessage,
                );
            } else {
                renderChatBubbles([webchatResponse.text], false);
            }
        }
    }

    scrollWebchatContent(chatBubblesWrapperId);
};
